import { useMutation, useQuery } from "react-query";
import { AxiosError, AxiosResponse } from "axios";
import { config } from "../config";
import { ApiError, QueryOptions, Truck, TruckPayload } from "../types";
import { client } from "./axios";
import { DEFAULT_QUERY_OPTIONS } from "../constants";

export const useFetchTrucksQuery = (
  orgId: number,
  queryOptions?: QueryOptions<Truck[]>,
) => {
  const fetchTrucks = async (): Promise<Truck[]> => {
    const path = config.api.truckService.getAllTrucks.replace(
      "{orgId}",
      orgId.toString(),
    );
    const response = await client.get<{ response: Truck[] }>(path);
    return response.data.response;
  };

  return useQuery(["fetchTrucks", orgId], fetchTrucks, {
    ...queryOptions,
    ...DEFAULT_QUERY_OPTIONS,
  });
};

export const useCreateTruckMutation = () => {
  const mutation = useMutation<
    AxiosResponse,
    AxiosError<ApiError>,
    { orgId: number } & TruckPayload,
    unknown
  >(async (data: { orgId: number } & TruckPayload) => {
    const { orgId, ...truck } = data;
    const path = config.api.truckService.createTruck.replace(
      "{orgId}",
      orgId.toString(),
    );

    const response = await client.post(path, truck);
    return response;
  });

  return mutation;
};

export const useUpdateTruckMutation = () => {
  const mutation = useMutation<
    AxiosResponse,
    AxiosError<ApiError>,
    { orgId: number; id: number } & TruckPayload,
    unknown
  >(async (data: { orgId: number; id: number } & TruckPayload) => {
    const { orgId, id, ...truck } = data;
    const path = config.api.truckService.updateTruck
      .replace("{orgId}", orgId.toString())
      .replace("{id}", id.toString());

    const response = await client.patch(path, truck);
    return response;
  });

  return mutation;
};
